/* ============================================================
   ION X — Campo Bioeléctrico · JS global
   ============================================================ */
(function () {
  'use strict';

  /* ---------- utilidades ---------- */
  function formatMoney(cents) {
    var fmt = (window.IONX && window.IONX.moneyFormat) || '$ {{amount}}';
    var value = (cents / 100).toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    return fmt.replace(/\{\{\s*amount[^}]*\}\}/, value);
  }

  var toastEl;
  function toast(msg) {
    if (!toastEl) {
      toastEl = document.createElement('div');
      toastEl.className = 'toast';
      document.body.appendChild(toastEl);
    }
    toastEl.textContent = msg;
    toastEl.classList.add('is-visible');
    clearTimeout(toastEl._t);
    toastEl._t = setTimeout(function () { toastEl.classList.remove('is-visible'); }, 2600);
  }

  /* ---------- drawer del carrito ---------- */
  var drawer = document.getElementById('CartDrawer');

  function openDrawer() {
    if (!drawer) return;
    drawer.classList.add('is-open');
    document.body.style.overflow = 'hidden';
  }
  function closeDrawer() {
    if (!drawer) return;
    drawer.classList.remove('is-open');
    document.body.style.overflow = '';
  }

  function refreshDrawer(openAfter) {
    if (!drawer) return Promise.resolve();
    var sectionId = drawer.dataset.sectionId;
    return fetch(window.location.pathname + '?sections=' + sectionId)
      .then(function (r) { return r.json(); })
      .then(function (data) {
        var html = data[sectionId];
        if (!html) return;
        var tmp = document.createElement('div');
        tmp.innerHTML = html;
        var fresh = tmp.querySelector('#CartDrawer');
        if (fresh) {
          drawer.innerHTML = fresh.innerHTML;
          drawer.className = fresh.className + (drawer.classList.contains('is-open') ? ' is-open' : '');
        }
        updateCounts();
        if (openAfter) openDrawer();
      })
      .catch(function () {});
  }

  function updateCounts() {
    fetch((window.IONX && window.IONX.cartUrl || '/cart') + '.js')
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        document.querySelectorAll('[data-cart-count]').forEach(function (el) { el.textContent = cart.item_count; });
      })
      .catch(function () {});
  }

  document.addEventListener('click', function (e) {
    if (e.target.closest('[data-drawer-open]')) { e.preventDefault(); openDrawer(); }
    if (e.target.closest('[data-drawer-close]')) { e.preventDefault(); closeDrawer(); }
  });
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') closeDrawer();
  });

  /* ---------- agregar al carrito (AJAX en todos los form de producto) ---------- */
  document.addEventListener('submit', function (e) {
    var form = e.target;
    if (!form.closest('product-form')) return;
    e.preventDefault();
    var btn = form.querySelector('[name="add"]');
    if (btn) btn.classList.add('is-adding');
    var fd = new FormData(form);
    fetch((window.IONX && window.IONX.cartAddUrl) || '/cart/add', {
      method: 'POST',
      body: fd,
      headers: { 'X-Requested-With': 'XMLHttpRequest', 'Accept': 'application/json' }
    })
      .then(function (r) { return r.json().then(function (j) { return { ok: r.ok, json: j }; }); })
      .then(function (res) {
        if (btn) btn.classList.remove('is-adding');
        if (!res.ok) {
          toast(res.json && res.json.description ? res.json.description : 'No se pudo agregar. Intenta de nuevo.');
          return;
        }
        refreshDrawer(true);
      })
      .catch(function () {
        if (btn) btn.classList.remove('is-adding');
        toast('No se pudo agregar. Revisa tu conexión.');
      });
  });

  /* ---------- cambios de cantidad / quitar (drawer y página carrito) ---------- */
  function changeLine(lineIndex, quantity, lineEl) {
    if (lineEl) lineEl.classList.add('is-updating');
    fetch((window.IONX && window.IONX.cartChangeUrl) || '/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ line: lineIndex, quantity: quantity })
    })
      .then(function (r) { return r.json(); })
      .then(function () {
        if (document.querySelector('.cart-page')) {
          window.location.reload();
        } else {
          refreshDrawer(false);
        }
      })
      .catch(function () {
        if (lineEl) lineEl.classList.remove('is-updating');
        toast('No se pudo actualizar el carrito.');
      });
  }

  document.addEventListener('click', function (e) {
    var chg = e.target.closest('[data-qty-change]');
    if (chg && chg.dataset.lineIndex) {
      var input = chg.parentElement.querySelector('[data-qty-input]');
      var next = Math.max(0, parseInt(input.value || '0', 10) + parseInt(chg.dataset.qtyChange, 10));
      input.value = next;
      changeLine(parseInt(chg.dataset.lineIndex, 10), next, chg.closest('.line'));
      return;
    }
    var rm = e.target.closest('[data-line-remove]');
    if (rm) {
      changeLine(parseInt(rm.dataset.lineIndex, 10), 0, rm.closest('.line'));
    }
  });

  document.addEventListener('change', function (e) {
    var input = e.target.closest('[data-qty-input]');
    if (input && input.dataset.lineIndex) {
      changeLine(parseInt(input.dataset.lineIndex, 10), Math.max(0, parseInt(input.value || '0', 10)), input.closest('.line'));
    }
  });

  /* ---------- menú móvil (panel lateral) ---------- */
  var burger = document.querySelector('[data-burger]');
  var mnav = document.querySelector('[data-mobile-menu]');
  function openMenu() {
    if (!mnav) return;
    mnav.classList.add('is-open');
    mnav.setAttribute('aria-hidden', 'false');
    if (burger) burger.setAttribute('aria-expanded', 'true');
    document.body.style.overflow = 'hidden';
  }
  function closeMenu() {
    if (!mnav) return;
    mnav.classList.remove('is-open');
    mnav.setAttribute('aria-hidden', 'true');
    if (burger) burger.setAttribute('aria-expanded', 'false');
    if (!(drawer && drawer.classList.contains('is-open'))) document.body.style.overflow = '';
  }
  if (burger && mnav) {
    closeMenu();
    burger.addEventListener('click', function () {
      mnav.classList.contains('is-open') ? closeMenu() : openMenu();
    });
    document.addEventListener('click', function (e) {
      if (e.target.closest('[data-mobile-close]')) closeMenu();
    });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape') closeMenu(); });
    window.addEventListener('resize', function () { if (window.innerWidth > 860) closeMenu(); });
  }

  /* ---------- ingredientes desplegables: solo uno abierto por grupo ---------- */
  document.querySelectorAll('[data-mins], [data-ing-list]').forEach(function (group) {
    group.addEventListener('toggle', function (e) {
      var d = e.target;
      if (!d.matches('details.ing') || !d.open) return;
      group.querySelectorAll('details.ing[open]').forEach(function (o) { if (o !== d) o.open = false; });
    }, true);
  });

  /* ---------- video del hero (autoplay silencioso y seguro en iOS) ---------- */
  document.querySelectorAll('.hero__media video').forEach(function (v) {
    v.muted = true;
    v.defaultMuted = true;
    v.setAttribute('muted', '');
    v.setAttribute('playsinline', '');
    v.setAttribute('webkit-playsinline', '');
    v.loop = true;
    v.controls = false;
    var play = v.play();
    if (play && typeof play.catch === 'function') play.catch(function () {});
  });

  /* ---------- galería PDP: miniaturas en escritorio, deslizable + puntos en móvil ---------- */
  var gallery = document.querySelector('[data-gallery]');
  if (gallery) {
    var gTrack = gallery.querySelector('[data-gallery-track]');
    var gDots = gallery.querySelector('[data-gallery-dots]');
    var gSlides = gallery.querySelectorAll('.pdp__slide');
    if (gDots && gSlides.length > 1) {
      gSlides.forEach(function (_, i) { var d = document.createElement('i'); if (i === 0) d.className = 'is-on'; gDots.appendChild(d); });
    }
    function setActive(idx) {
      gSlides.forEach(function (s) { s.classList.toggle('is-active', String(s.dataset.slide) === String(idx)); });
      gallery.querySelectorAll('.pdp__thumb').forEach(function (t) { t.classList.toggle('is-active', t.dataset.thumb === String(idx)); });
      if (gDots) gDots.querySelectorAll('i').forEach(function (d, i) { d.classList.toggle('is-on', i === Number(idx)); });
    }
    gallery.addEventListener('click', function (e) {
      var thumb = e.target.closest('[data-thumb]');
      if (!thumb) return;
      setActive(thumb.dataset.thumb);
      if (gTrack && window.innerWidth <= 860) gTrack.scrollTo({ left: gTrack.clientWidth * Number(thumb.dataset.thumb), behavior: 'smooth' });
    });
    if (gTrack) {
      var gT;
      gTrack.addEventListener('scroll', function () {
        clearTimeout(gT);
        gT = setTimeout(function () {
          var idx = Math.round(gTrack.scrollLeft / gTrack.clientWidth);
          if (gDots) gDots.querySelectorAll('i').forEach(function (d, i) { d.classList.toggle('is-on', i === idx); });
        }, 60);
      }, { passive: true });
    }
  }

  /* ---------- carruseles genéricos (datos, FAQ, reseñas) ---------- */
  document.querySelectorAll('[data-carousel]').forEach(function (c) {
    var track = c.querySelector('[data-carousel-track]');
    var dots = c.querySelector('[data-carousel-dots]');
    var items = track ? Array.prototype.slice.call(track.children) : [];
    if (!track || items.length === 0) return;
    if (dots) items.forEach(function (_, i) { var d = document.createElement('i'); if (i === 0) d.className = 'is-on'; dots.appendChild(d); });
    function current() {
      var left = track.scrollLeft, best = 0, bestD = Infinity;
      items.forEach(function (it, i) { var d = Math.abs(it.offsetLeft - track.offsetLeft - left); if (d < bestD) { bestD = d; best = i; } });
      return best;
    }
    function go(i) {
      i = Math.max(0, Math.min(items.length - 1, i));
      track.scrollTo({ left: items[i].offsetLeft - track.offsetLeft, behavior: 'smooth' });
    }
    var prev = c.querySelector('[data-carousel-prev]'), next = c.querySelector('[data-carousel-next]');
    if (prev) prev.addEventListener('click', function () { go(current() - 1); });
    if (next) next.addEventListener('click', function () { go(current() + 1); });
    var t;
    track.addEventListener('scroll', function () {
      clearTimeout(t);
      t = setTimeout(function () {
        var i = current();
        if (dots) dots.querySelectorAll('i').forEach(function (d, k) { d.classList.toggle('is-on', k === i); });
      }, 60);
    }, { passive: true });
    /* al abrir una FAQ del carrusel, cerrar las demás para que el carril no crezca */
    track.addEventListener('toggle', function (e) {
      var d = e.target;
      if (!d.matches('details.qa') || !d.open) return;
      track.querySelectorAll('details.qa[open]').forEach(function (o) { if (o !== d) o.open = false; });
    }, true);
  });

  /* ---------- selector de variantes PDP ---------- */
  var mainForm = document.querySelector('[data-main-product]');
  if (mainForm) {
    var jsonEl = mainForm.querySelector('[data-variants-json]');
    var variants = jsonEl ? JSON.parse(jsonEl.textContent) : null;
    var idInput = mainForm.querySelector('[data-variant-id]');
    var addBtn = mainForm.querySelector('[data-add-btn]');
    var addLabel = mainForm.querySelector('[data-add-label]');
    var priceWrap = document.querySelector('[data-price-wrap] .price:not(.price--old)');
    var stickyPrice = document.querySelector('[data-sticky-price]');
    var stickyAdd = document.querySelector('[data-sticky-add]');

    function currentOptions() {
      var opts = [];
      mainForm.querySelectorAll('fieldset.pdp__option').forEach(function (fs) {
        var checked = fs.querySelector('input:checked');
        opts.push(checked ? checked.value : null);
      });
      return opts;
    }

    function syncVariant() {
      if (!variants) return;
      var opts = currentOptions();
      var match = variants.find(function (v) {
        return v.options.every(function (o, i) { return o === opts[i]; });
      });
      if (match) {
        idInput.value = match.id;
        if (priceWrap) priceWrap.textContent = formatMoney(match.price);
        if (stickyPrice) stickyPrice.textContent = formatMoney(match.price);
        var available = match.available;
        [addBtn, stickyAdd].forEach(function (b) { if (b) b.disabled = !available; });
        if (addLabel) addLabel.textContent = available ? 'Agregar al carrito' : 'Agotado';
        if (stickyAdd) stickyAdd.textContent = available ? 'Agregar' : 'Agotado';
        var url = new URL(window.location);
        url.searchParams.set('variant', match.id);
        window.history.replaceState({}, '', url);
      } else {
        [addBtn, stickyAdd].forEach(function (b) { if (b) b.disabled = true; });
        if (addLabel) addLabel.textContent = 'No disponible';
      }
    }
    mainForm.querySelectorAll('[data-option-input]').forEach(function (i) { i.addEventListener('change', syncVariant); });

    /* cantidad PDP */
    document.addEventListener('click', function (e) {
      var q = e.target.closest('[data-pdp-qty]');
      if (!q) return;
      var input = mainForm.querySelector('[data-pdp-qty-input]');
      input.value = Math.max(1, parseInt(input.value || '1', 10) + parseInt(q.dataset.pdpQty, 10));
    });

    /* barra fija móvil */
    var sticky = document.querySelector('[data-pdp-sticky]');
    var buyRow = mainForm.querySelector('.pdp__buyrow');
    if (sticky && buyRow && 'IntersectionObserver' in window) {
      sticky.hidden = false;
      sticky.classList.remove('is-visible');
      var io = new IntersectionObserver(function (entries) {
        sticky.classList.toggle('is-visible', !entries[0].isIntersecting);
      }, { rootMargin: '-70px 0px 0px 0px' });
      io.observe(buyRow);
      if (stickyAdd) {
        stickyAdd.addEventListener('click', function () {
          var form = mainForm.querySelector('form');
          if (!form) return;
          if (typeof form.requestSubmit === 'function') { form.requestSubmit(); }
          else { form.dispatchEvent(new Event('submit', { cancelable: true, bubbles: true })); }
        });
      }
    }
  }

  /* ---------- productos relacionados ---------- */
  var rel = document.querySelector('related-products');
  if (rel && rel.dataset.url && rel.children.length === 0) {
    fetch(rel.dataset.url)
      .then(function (r) { return r.text(); })
      .then(function (html) {
        var tmp = document.createElement('div');
        tmp.innerHTML = html;
        var inner = tmp.querySelector('related-products');
        if (inner && inner.innerHTML.trim()) {
          rel.innerHTML = inner.innerHTML;
        } else {
          var sec = rel.closest('.sec');
          if (sec) sec.style.display = 'none';
        }
      })
      .catch(function () {});
  }

  /* ---------- link recuperar contraseña ---------- */
  var recoverLink = document.querySelector('[data-show-recover]');
  if (recoverLink) {
    var recoverBox = document.getElementById('recover');
    recoverLink.addEventListener('click', function (e) {
      e.preventDefault();
      if (recoverBox) recoverBox.hidden = !recoverBox.hidden;
    });
    if (window.location.hash === '#recover' && recoverBox) recoverBox.hidden = false;
  }

  /* ---------- carrito: dirección + código postal (colonia / ciudad / estado) ---------- */
  var cpBox = document.querySelector('[data-cp]');
  if (cpBox) {
    var cpInput = cpBox.querySelector('[data-cp-input]');
    var cpCol = cpBox.querySelector('[data-cp-colonia]');
    var cpCity = cpBox.querySelector('[data-cp-ciudad]');
    var cpState = cpBox.querySelector('[data-cp-estado]');
    var cpMsg = cpBox.querySelector('[data-cp-msg]');
    var cpRates = cpBox.querySelector('[data-cp-rates]');
    var token = (window.IONX && window.IONX.copomexToken) || '';
    var PROV = { 'Aguascalientes':'AGS','Baja California':'BC','Baja California Sur':'BCS','Campeche':'CAMP','Chiapas':'CHIS','Chihuahua':'CHIH','Ciudad de México':'DF','Distrito Federal':'DF','Coahuila':'COAH','Coahuila de Zaragoza':'COAH','Colima':'COL','Durango':'DGO','Guanajuato':'GTO','Guerrero':'GRO','Hidalgo':'HGO','Jalisco':'JAL','México':'MEX','Estado de México':'MEX','Michoacán':'MICH','Michoacán de Ocampo':'MICH','Morelos':'MOR','Nayarit':'NAY','Nuevo León':'NL','Oaxaca':'OAX','Puebla':'PUE','Querétaro':'QRO','Quintana Roo':'Q ROO','San Luis Potosí':'SLP','Sinaloa':'SIN','Sonora':'SON','Tabasco':'TAB','Tamaulipas':'TAMPS','Tlaxcala':'TLAX','Veracruz':'VER','Veracruz de Ignacio de la Llave':'VER','Yucatán':'YUC','Zacatecas':'ZAC' };

    function setMsg(txt, kind) {
      if (!cpMsg) return;
      cpMsg.textContent = txt || '';
      cpMsg.classList.toggle('is-err', kind === 'err');
      cpMsg.classList.toggle('is-ok', kind === 'ok');
    }
    function fillColonias(list, selected) {
      cpCol.innerHTML = '';
      if (!list.length) {
        var e = document.createElement('option');
        e.value = ''; e.textContent = 'Escribe tu código postal';
        cpCol.appendChild(e);
        return;
      }
      list.forEach(function (c) {
        var o = document.createElement('option');
        o.value = c; o.textContent = c;
        if (selected && selected === c) o.selected = true;
        cpCol.appendChild(o);
      });
    }
    var saveT;
    function saveAttrs() {
      clearTimeout(saveT);
      saveT = setTimeout(function () {
        var attrs = {};
        cpBox.querySelectorAll('[data-cp-save]').forEach(function (el) {
          var m = /attributes\[(.+)\]/.exec(el.getAttribute('name') || '');
          if (m) attrs[m[1]] = el.value || '';
        });
        fetch((window.IONX && window.IONX.cartUpdateUrl) || '/cart/update.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          body: JSON.stringify({ attributes: attrs })
        }).catch(function () {});
      }, 450);
    }
    function rates(zip, provName) {
      if (!cpRates) return;
      var code = PROV[provName] || '';
      var url = '/cart/shipping_rates.json?shipping_address[zip]=' + encodeURIComponent(zip) +
                '&shipping_address[country]=MX' + (code ? '&shipping_address[province]=' + encodeURIComponent(code) : '');
      fetch(url).then(function (r) { return r.json(); }).then(function (j) {
        var list = j && j.shipping_rates;
        if (!list || !list.length) { cpRates.hidden = true; return; }
        cpRates.innerHTML = list.map(function (r) {
          var cents = Math.round(parseFloat(r.price) * 100);
          return '<div><span>' + r.name + '</span><b>' + (cents === 0 ? 'Gratis' : formatMoney(cents)) + '</b></div>';
        }).join('');
        cpRates.hidden = false;
      }).catch(function () { cpRates.hidden = true; });
    }

    /* Fuentes de datos, en orden: COPOMEX (si hay token) → SEPOMEX abierto → Zippopotam */
    function fromCopomex(zip) {
      return fetch('https://api.copomex.com/query/info_cp/' + zip + '?type=simplified&token=' + encodeURIComponent(token))
        .then(function (r) { return r.json(); })
        .then(function (j) {
          var r = j && j.response; if (!r) throw new Error('nf');
          var col = r.asentamiento || [];
          if (typeof col === 'string') col = [col];
          return { colonias: col, city: r.municipio || r.ciudad || '', state: r.estado || '' };
        });
    }
    function fromSepomex(zip) {
      return fetch('https://api-sepomex.hckdrk.mx/query/info_cp/' + zip)
        .then(function (r) { if (!r.ok) throw new Error('nf'); return r.json(); })
        .then(function (j) {
          var rows = Array.isArray(j) ? j : [j];
          var out = { colonias: [], city: '', state: '' };
          rows.forEach(function (row) {
            var d = row && row.response;
            if (!d || !d.asentamiento) return;
            out.colonias.push(d.asentamiento);
            out.city = out.city || d.municipio || d.ciudad || '';
            out.state = out.state || d.estado || '';
          });
          if (!out.colonias.length) throw new Error('nf');
          return out;
        });
    }
    function fromZippo(zip) {
      return fetch('https://api.zippopotam.us/mx/' + zip)
        .then(function (r) { if (!r.ok) throw new Error('nf'); return r.json(); })
        .then(function (j) {
          var places = j.places || [];
          if (!places.length) throw new Error('nf');
          return { colonias: places.map(function (x) { return x['place name']; }), city: '', state: places[0]['state'] || '' };
        });
    }

    function lookup(zip) {
      setMsg('Buscando tu código postal…');
      var chain = token ? fromCopomex(zip).catch(function () { return fromSepomex(zip); }) : fromSepomex(zip);
      chain.catch(function () { return fromZippo(zip); })
        .then(function (d) {
          fillColonias(d.colonias, cpCol.dataset.selected || '');
          if (d.city) cpCity.value = d.city;
          if (d.state) cpState.value = d.state;
          if (!d.city) setMsg('Encontramos ' + d.colonias.length + ' colonias. Confirma tu ciudad o municipio.');
          else setMsg('Listo: ' + d.city + ', ' + d.state + '. Elige tu colonia.', 'ok');
          saveAttrs();
          rates(zip, d.state);
        })
        .catch(function () {
          fillColonias([]);
          setMsg('No encontramos ese código postal. Escribe tu colonia, ciudad y estado a mano.', 'err');
          if (cpRates) cpRates.hidden = true;
          /* deja capturar la colonia a mano */
          if (cpCol && cpCol.tagName === 'SELECT' && !cpCol.dataset.swapped) {
            var input = document.createElement('input');
            input.type = 'text';
            input.setAttribute('name', cpCol.getAttribute('name'));
            input.setAttribute('data-cp-save', '');
            input.placeholder = 'Escribe tu colonia';
            input.value = '';
            cpCol.parentNode.replaceChild(input, cpCol);
            input.dataset.swapped = '1';
            cpCol = input;
            cpCol.addEventListener('input', saveAttrs);
          }
        });
    }

    cpInput.addEventListener('input', function () {
      cpInput.value = cpInput.value.replace(/\D/g, '').slice(0, 5);
      if (cpInput.value.length === 5) lookup(cpInput.value);
    });
    cpBox.addEventListener('change', function (e) { if (e.target.matches('[data-cp-save]')) saveAttrs(); });
    cpBox.addEventListener('input', function (e) { if (e.target.matches('input[data-cp-save]')) saveAttrs(); });
    if (cpInput.value.length === 5) {
      cpCol.dataset.selected = cpCol.value || '';
      lookup(cpInput.value);
    }
  }

  /* ---------- sugerencias en carrito: agregar sin salir ---------- */
  document.addEventListener('submit', function (e) {
    if (e.target.closest('.upsell__card')) {
      setTimeout(function () { if (document.querySelector('.cart-page')) window.location.reload(); }, 700);
    }
  });

  /* ---------- filtro por tema (escuela, testimonios) ---------- */
  document.querySelectorAll('[data-school-filter], [data-filter]').forEach(function (bar) {
    var list = bar.parentElement.querySelector('[data-school], [data-filter-list]');
    if (!list) return;
    bar.addEventListener('click', function (e) {
      var btn = e.target.closest('[data-cat]');
      if (!btn) return;
      var cat = btn.dataset.cat;
      bar.querySelectorAll('[data-cat]').forEach(function (b) { b.classList.toggle('is-on', b === btn); });
      list.querySelectorAll('[data-cat]').forEach(function (l) {
        var show = cat === 'all' || l.dataset.cat === cat;
        l.hidden = !show;
        if (!show && 'open' in l) l.open = false;
      });
    });
  });

  /* ---------- momentos y lecciones: uno abierto a la vez ---------- */
  document.querySelectorAll('[data-moms], .lessons').forEach(function (group) {
    group.addEventListener('toggle', function (e) {
      var d = e.target;
      if (!d.matches('details') || !d.open) return;
      group.querySelectorAll('details[open]').forEach(function (o) { if (o !== d) o.open = false; });
    }, true);
  });




  /* ---------- pago: prellenar la dirección del checkout con lo capturado en el carrito ---------- */
  (function () {
    var MAP = { 'Código postal': 'zip', 'Colonia': 'address2', 'Calle y número': 'address1', 'Interior': null, 'Ciudad': 'city', 'Estado': 'province' };
    function checkoutUrl(attrs) {
      var base = ((window.IONX && window.IONX.cartUrl) || '/cart') + '/checkout';
      var q = [];
      var a2 = [attrs['Colonia'], attrs['Interior']].filter(Boolean).join(', ');
      Object.keys(MAP).forEach(function (k) {
        var field = MAP[k];
        if (!field || !attrs[k]) return;
        var val = field === 'address2' ? a2 : attrs[k];
        q.push('checkout[shipping_address][' + field + ']=' + encodeURIComponent(val));
      });
      if (q.length) q.push('checkout[shipping_address][country]=MX');
      return q.length ? base + '?' + q.join('&') : base;
    }
    function attrsFromForm(form) {
      var out = {};
      form.querySelectorAll('[data-cp-save]').forEach(function (el) {
        var m = /attributes\[(.+)\]/.exec(el.getAttribute('name') || '');
        if (m && el.value) out[m[1]] = el.value;
      });
      return out;
    }
    document.addEventListener('click', function (e) {
      var btn = e.target.closest('.cart-summary__checkout');
      if (btn) {
        var form = btn.closest('form');
        if (!form) return;
        e.preventDefault();
        window.location.href = checkoutUrl(attrsFromForm(form));
        return;
      }
      var link = e.target.closest('.drawer__ctas a[href$="/checkout"]');
      if (link) {
        e.preventDefault();
        fetch(((window.IONX && window.IONX.cartUrl) || '/cart') + '.js')
          .then(function (r) { return r.json(); })
          .then(function (cart) { window.location.href = checkoutUrl(cart.attributes || {}); })
          .catch(function () { window.location.href = link.href; });
      }
    });
  })();

  /* ---------- hero carrusel ---------- */
  (function () {
    var hero = document.querySelector('[data-hero-slides]');
    if (!hero) return;
    var track = hero.querySelector('[data-hslides-track]');
    var slides = Array.prototype.slice.call(track.querySelectorAll('.hslide'));
    var dots = Array.prototype.slice.call(hero.querySelectorAll('[data-hslides-go]'));
    if (slides.length < 2) return;
    var idx = 0, timer, delay = parseInt(hero.dataset.autoplay || '0', 10) * 1000;
    var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    function mark(i) {
      idx = i;
      slides.forEach(function (s, k) { s.classList.toggle('is-on', k === i); });
      dots.forEach(function (d, k) { d.classList.toggle('is-on', k === i); d.setAttribute('aria-selected', k === i ? 'true' : 'false'); });
    }
    function go(i, smooth) {
      i = (i + slides.length) % slides.length;
      track.scrollTo({ left: slides[i].offsetLeft, behavior: smooth === false ? 'auto' : 'smooth' });
      mark(i);
    }
    var prev = hero.querySelector('[data-hslides-prev]'), next = hero.querySelector('[data-hslides-next]');
    if (prev) prev.addEventListener('click', function () { go(idx - 1); restart(); });
    if (next) next.addEventListener('click', function () { go(idx + 1); restart(); });
    dots.forEach(function (d) { d.addEventListener('click', function () { go(parseInt(d.dataset.hslidesGo, 10)); restart(); }); });
    var t;
    track.addEventListener('scroll', function () {
      clearTimeout(t);
      t = setTimeout(function () { mark(Math.round(track.scrollLeft / track.clientWidth)); }, 80);
    }, { passive: true });
    function stop() { clearInterval(timer); timer = null; }
    function start() {
      if (!delay || reduce || timer) return;
      timer = setInterval(function () { if (document.hidden) return; go(idx + 1); }, delay);
    }
    function restart() { stop(); start(); }
    ['touchstart', 'pointerdown', 'focusin'].forEach(function (ev) { track.addEventListener(ev, stop, { passive: true }); });
    track.addEventListener('mouseenter', stop);
    track.addEventListener('mouseleave', start);
    hero.addEventListener('keydown', function (e) {
      if (e.key === 'ArrowRight') { go(idx + 1); restart(); }
      if (e.key === 'ArrowLeft') { go(idx - 1); restart(); }
    });
    if ('IntersectionObserver' in window) {
      new IntersectionObserver(function (en) { en[0].isIntersecting ? start() : stop(); }, { threshold: .3 }).observe(hero);
    } else { start(); }
    window.addEventListener('resize', function () { go(idx, false); });
  })();

  /* ---------- encabezado fijo: sombra al hacer scroll ---------- */
  (function () {
    var hdr = document.querySelector('.section-header') || (document.querySelector('[data-header]') || {}).parentElement;
    if (!hdr) return;
    var onScroll = function () { hdr.classList.toggle('is-scrolled', window.scrollY > 8); };
    window.addEventListener('scroll', onScroll, { passive: true });
    onScroll();
  })();

  /* ---------- artículo: progreso, índice y copiar enlace ---------- */
  (function () {
    var body = document.querySelector('[data-article-body]');
    if (!body) return;
    var bar = document.querySelector('[data-read-progress]');
    if (bar) {
      var upd = function () {
        var r = body.getBoundingClientRect();
        var total = r.height - window.innerHeight * 0.5;
        var p = total > 0 ? Math.min(1, Math.max(0, -r.top / total)) : 0;
        bar.style.width = (p * 100).toFixed(1) + '%';
      };
      window.addEventListener('scroll', upd, { passive: true });
      upd();
    }
    var toc = document.querySelector('[data-toc]');
    var list = document.querySelector('[data-toc-list]');
    var heads = body.querySelectorAll('h2, h3');
    if (toc && list && heads.length >= 2) {
      heads.forEach(function (h, i) {
        var txt = (h.textContent || '').trim();
        if (!txt) return;
        if (!h.id) h.id = 'sec-' + (i + 1) + '-' + txt.toLowerCase().normalize('NFD').replace(/[\u0300-\u036f]/g, '').replace(/[^a-z0-9]+/g, '-').replace(/^-|-$/g, '').slice(0, 40);
        var li = document.createElement('li');
        if (h.tagName === 'H3') li.className = 'is-sub';
        var a = document.createElement('a');
        a.href = '#' + h.id;
        a.textContent = txt;
        li.appendChild(a);
        list.appendChild(li);
      });
      toc.hidden = false;
    }
  })();

  /* ---------- copiar enlace (artículos y guías) + abrir guía por ancla ---------- */
  (function () {
    document.addEventListener('click', function (e) {
      var b = e.target.closest('[data-copy-link]');
      if (!b) return;
      var url = b.getAttribute('data-copy-link');
      var done = function () { toast('Enlace copiado'); };
      if (navigator.clipboard && navigator.clipboard.writeText) navigator.clipboard.writeText(url).then(done).catch(function () { window.prompt('Copia el enlace:', url); });
      else window.prompt('Copia el enlace:', url);
    });
    function openHash() {
      var id = (location.hash || '').slice(1);
      if (!id) return;
      var el = document.getElementById(id);
      if (el && el.tagName === 'DETAILS' && el.classList.contains('guide')) {
        el.open = true;
        setTimeout(function () { el.scrollIntoView({ behavior: 'smooth', block: 'start' }); }, 50);
      }
    }
    window.addEventListener('hashchange', openHash);
    openHash();
  })();

  /* ---------- reveal on scroll ---------- */
  if ('IntersectionObserver' in window) {
    var targets = document.querySelectorAll('.sec .sechead, .card, .q, .fmt, .guarantee, .vs__col, .prop, .fcard, .moment, .tb__card, .jrn__card, .mom, .lesson, .founders__img, .founders__txt, .fnote, .topics li, .tb-head, .claim');
    var revealObs = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) {
        if (en.isIntersecting) { en.target.classList.add('is-in'); revealObs.unobserve(en.target); }
      });
    }, { threshold: 0, rootMargin: '0px 0px -6% 0px' });
    targets.forEach(function (t, i) {
      t.classList.add('reveal');
      t.style.transitionDelay = (i % 4) * 60 + 'ms';
      revealObs.observe(t);
    });
    /* red de seguridad: nada puede quedarse invisible pase lo que pase */
    setTimeout(function () {
      document.querySelectorAll('.reveal:not(.is-in)').forEach(function (t) {
        var r = t.getBoundingClientRect();
        if (r.top < window.innerHeight && r.bottom > 0) t.classList.add('is-in');
      });
    }, 900);
    window.addEventListener('load', function () {
      setTimeout(function () {
        document.querySelectorAll('.reveal:not(.is-in)').forEach(function (t) {
          var r = t.getBoundingClientRect();
          if (r.top < window.innerHeight * 1.1) t.classList.add('is-in');
        });
      }, 400);
    });
  }
})();
